<template>
  <div class="c-tabs-wrapper">
    <ul class="c-tabs-group">
      <li v-for="(v, k) in tabList" v-bind:key="k" :class="v.state" @click.self="switchTab(k)">
        {{ v.text }}<i v-show="k != tabList.length - 1"></i>
      </li>
    </ul>
    <div class="blockGroup" ref="blockGroup">
      <slot></slot>
    </div>
  </div>
</template>

<script>
// 参数说明
// index 初始选择标签
export default {
  name: 'c-tabs',
  props: ['index'],
  data() {
    return {
      tabList: [],
    }
  },
  methods: {
    switchTab(k) {
      if (this.tabList[k].state) return
      // 标签切换
      for (let i = 0; i < this.tabList.length; i += 1) {
        const item = this.tabList[i]
        item.state = ''
        this.$set(this.tabList, i, item)
      }
      const v = this.tabList[k]
      v.state = 'c-active'
      this.$set(this.tabList, k, v)

      // block切换
      this.switchBlock(k)

      // 事件
      this.$emit('tabClick', k)
    },
    switchBlock(k) {
      this.$nextTick(() => {
        const blockList = this.$refs.blockGroup.children
        for (let i = 0; i < blockList.length; i += 1) {
          const block = blockList[i]
          block.style.display = 'none'
        }
        blockList[k].style.display = 'block'
      })
    },
  },
  mounted() {
    const slot = this.$slots.default
    for (let i = 0; i < slot.length; i += 1) {
      if (slot[i].tag === 'div') {
        this.tabList.push({
          text: slot[i].data.attrs.label,
          state: '',
        })
      }
    }
    const index = this.index === undefined ? 0 : this.index
    this.tabList[index].state = 'c-active'
    this.switchBlock(index)
  },
  created() {
    // this.init();
  },
}
</script>

<style lang='less'>
ul {
  padding-inline-start: 10px;
}
.c-tabs-wrapper {
  /*height: 500px;*/
  background-color: transparent;
  height: 100%;
}
.c-tabs-group {
  height: 16px;
  background-color: transparent;
}
.c-tabs-group li {
  float: left;
  position: relative;
  box-sizing: border-box;
  width: 40px;
  line-height: 16px;
  padding-bottom: 1px;
  text-align: center;
  font-size: 13px;
  color: #929292;
  cursor: pointer;
  font-weight: 100;
}
.c-tabs-group li i {
  position: absolute;
  top: 3px;
  bottom: 0;
  right: 0;
  width: 2px;
  height: 1em;
  background-color: #666666;
}
.c-tabs-group li.c-active {
  /* top: -1px; */
  color: #3b90e6;
  font-weight: 700;
}
.c-tabs-group li:hover {
  color: #3b90e6;
}
.c-tabs-group li.c-active i {
  display: block;
}
.blockGroup {
  /*padding: 10px;*/
  height: calc(~'100% - 25px');
}

li {
  list-style: none;
}
</style>
